import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

import { PY_BLUEPRINT } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  my: PY_BLUEPRINT,
  pt: [40, 60],
  pb: [40, 40, 62, 62, 74],
})`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${themeGet('colors.calculator.light')};
  position: relative;
  overflow: hidden;
`
